// extracted by mini-css-extract-plugin
export default {"productGallery":"CK-z","inQuickShop":"DK-z"};